<p-toast [life]="3000" [sticky]="false"></p-toast>

<form class="form-horizontal" #form="ngForm" *ngIf="!flagAssignProvider" style="min-height: 100px"
  (ngSubmit)="onSubmit()">
  <div class="container-fluid px-5">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" styleClass="steps-custom"
      (activeIndexChange)="indexChange($event)" [ngClass]="'p-steps-morfeo-' + activeIndex" [readonly]="true">
    </p-steps>
    <br>
    <div *ngIf="activeIndex != 1">
      <p-dialog [(visible)]="showstep" [modal]="true" [draggable]="false" [blockScroll]="true" [style]="{width: '50vw'}"
        [ngClass]="'stepdialog'">
  <ng-template pTemplate="header">
    <div *ngIf="activeIndex==0">
          {{ 'Assign Service' | translate }}
        </div>
    <div *ngIf="activeIndex==1">
          {{ 'Assign Provider' | translate }}
        </div>
    <div *ngIf="activeIndex==2">
          {{ 'Notify to customer' | translate }}
        </div>
    <div *ngIf="activeIndex==3">
          {{ 'Provider Arrived' | translate }}
        </div>
    <div *ngIf="activeIndex==50">
          {{ 'Arrival registered from the app' | translate }}
        </div>
    <div *ngIf="activeIndex==4">
          {{ 'Provider Not Assigned' | translate }}
        </div>
  </ng-template>
        
        
        
        
        
        
        <div *ngIf="activeIndex==0">
        </div>
        <div *ngIf="activeIndex==1;">
        </div>
        <div *ngIf="activeIndex==2;">
          <app-assistance-ticket-information [activeIndex]="activeIndex" [category]="editcategory"
            [service]="editservice" [assistancecase]="assistancecase" [provider]="editprovider"
            [editticket]="editticket"></app-assistance-ticket-information>
          <div class="form-group">
            <label class="control-label col-sm-12">
              {{ 'Comment' | translate }}:
            </label>
            <div class="col-sm-12">
              <textarea placeholder="{{ 'Write a comment' | translate }}..." rows="5" cols="10" class="form-control"
                [(ngModel)]="comment" name="comment" required>
              </textarea>
            </div>
          </div>
        </div>
        <div *ngIf="activeIndex==3;">
          <app-assistance-ticket-information [activeIndex]="activeIndex" [category]="editcategory"
            [service]="editservice" [assistancecase]="assistancecase" [provider]="editprovider"
            [editticket]="editticket"></app-assistance-ticket-information>
          <div class="form-group">
            <label class="control-label col-sm-12">{{ 'Comment' | translate }}:</label>
            <div class="col-sm-12">
              <textarea rows="5" cols="10" class="form-control" placeholder="{{ 'Write a comment' | translate }}..."
                [(ngModel)]="comment" name="comment" required>
              </textarea>
            </div>
          </div>
        </div>
        <div *ngIf="activeIndex==4;">
          <div class="form-group">
            <label class="control-label col-sm-12">{{ 'Comment' | translate }}:</label>
            <div class="col-sm-12">
              {{ "Provider is not assigned, please reassign it" | translate }}
            </div>
          </div>
        </div>
        <div class="footer-btns" visible="false">
          <div *ngIf="activeIndex!=4;">
            <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="onCancel()">{{ 'Cancel' |
              translate }}</button>
            <button (click)="Enviarcartaprov()" class="btn primary-btn primary-btn-fw" *ngIf="activateemail">
              {{ 'Send' | translate }}
            </button>
            <button (click)="Generarcarta()" class="btn primary-btn primary-btn-fw" *ngIf="cartas">
              {{ 'Generate' | translate }}
            </button>
            <button type="submit" class="btn primary-btn primary-btn-fw"
              [disabled]="form.form.invalid || form.form.pending || isDisabled" *ngIf="activeIndex != 1">
              {{ 'Save' | translate }}
            </button>
            <button class="btn primary-btn primary-btn-fw" *ngIf="activeIndex == 1"
              (click)="onSelectAssignProvider()">{{ 'Assign Provider' | translate }}</button>
          </div>
          <div *ngIf="activeIndex==4;">
            <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="onCancel()">{{ 'Cancel' |
              translate }}</button>
          </div>
        </div>
      </p-dialog>
    </div>
  </div>
</form>


<!-- ASIGNACION DE PROVEEDOR  -->
<div class="div-assign-provider" *ngIf="activeIndex==1 && flagAssignProvider">
  <div style="width: 100%;">
    <div class="card list-providers">
      
      <div class="card-body" style="height: 500px; overflow-y: scroll; padding-bottom: 80px;" infinite-scroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="300"
            [infiniteScrollDisabled]="!hasMoreProviders"
            [scrollWindow]="false"
            (scrolled)="loadMoreProviders()">
        <!-- TITLE -->
        <div class="mb-3 row">
          <h2 class="col-sm-4  align-self-center  h2-tilte">
            <strong (click)="goToBack()" style="cursor: pointer;">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              {{ 'Providers' | translate }}
            </strong>
          </h2>
          <div class="col-sm-4" *ngIf="assistance_plan_service.buca_apply !== 1 && assistance_plan_service.sinister_apply !== 1">
            <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="showModalOutOfNetworkProvider()">
              <strong>{{ 'Out of network provider' | translate }}</strong>
            </button>
          </div>
          <div class="col-sm-4" *ngIf="isNewConfigActive">
            <button type="button" class="btn secundary-btn secundary-btn-fw" [ngClass]="{'active': polygonFilter}" (click)="activatePolygonFilter()">
              <strong>{{ 'Coverage Area' | translate }}</strong>
            </button>
          </div>
        </div>

        <div class="search-input" >
          <strong>Buscar:</strong>
            <div style="width: 65%; display: flex; justify-content: center; align-items: center; gap:10px">
              <button (click)="restartProviders()" style=" background-color:white;
              border:none; width:30px; height: 30px; border-radius: 50%; box-shadow: inset 0 1px 1px rgba(0,0,0,.075);"><i class="fas fa-sync"></i></button>
              <mat-form-field style="width: 95%;" appearance="fill">
              <input
                type="text"
                matInput
                placeholder="Buscar proveedor"
                [formControl]="providerCtrl"
                [matAutocomplete]="auto">
                
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="onProviderSelected($event.option.value)">
                <mat-option *ngFor="let provider of filteredProviders" [value]="provider" style="display: flex; align-items: center;">
                  <span style="font-weight: bold; font-size: 10px;"> {{provider.site_name}}</span> - <span style="font-size: 10px;">{{ provider.name }} </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
      </div>

        <div class="card internal-card mb-3" *ngFor="let provider of providers">
          
          <div class="card-body col" (mouseenter)="onProviderHover(provider)" (mouseleave)="onProviderHoverOut(provider)">
            <div class="row mb-2">
              <div class="col">
                <div style="display: flex; width: 100%; justify-content: space-between;">
                  <strong>{{ provider?.provider_site?.id }} {{ provider?.provider_site?.name }}</strong>
                  <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 1">
                    {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}}
                  </strong>
                  <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 2">
                    {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}} / Km
                  </strong>
                  <strong *ngIf="!provider?.provider?.price">
                    N/A
                  </strong>
                </div>
                <div style="display: flex; width: 100%; justify-content: space-between;">
                  <span style="font-size: 0.9rem;">{{ provider?.provider?.id }} {{ provider?.provider?.name
                    }}</span>
                  <em *ngIf="provider.users" class="fa fa-mobile fa-fw big-icon"
                    (click)="showProviderUsers(provider.users, provider)" style="cursor: pointer;"></em>
                  <span *ngIf="provider.priority">
                      <i class="fa fa-star" style="color: gold;"></i>
                      {{ provider.priority }}
                  </span>
                </div>

                <br>
                <span style="font-size: 0.7rem;"  *ngIf="provider?.city!='' && provider?.state!=''">{{ provider?.city}}, {{provider?.state}}</span>
                <br>
                <span style="font-size: 0.7rem;">{{ provider?.provider?.cabin_emails }}</span>
                <br>
                <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                  <span *ngIf="coveragePrice.id == provider?.assistancePrice_id" style="font-size: 0.7rem;">{{
                    "Attention Times" | translate }} {{ coveragePrice?.hour_end }} - {{ coveragePrice?.hour_start
                    }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ "Cancellation" | translate }} {{
                      coveragePrice?.price_cancellation }}%</span>
                  </div>
                </div>
                <div class="col">
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <span
                      *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{provider?.provider?.currency_symbol}}
                      {{ coveragePrice?.price_extra != null ? coveragePrice?.price_extra : '-' }}/km</span>
                  </div>
                </div>
                <div class="col">
                  <div *ngFor="let contactPhone of ((provider.provider_site.cabin_phones || '')).split(',')">
                    <span>
                      <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/phone.svg' | company"
                        alt=""> {{ contactPhone }}
                    </span>
                  </div>
                </div>
                <div class="col">
                  <span *ngIf="provider?.coverage?.coverage_type == 1">
                    {{ 'Plane' | translate }} {{ provider?.coverage?.plane }}
                  </span>
                  <span *ngIf="provider?.coverage?.coverage_type == 2">
                    {{ 'Foreign' | translate }}
                  </span>
                </div>
                <div class="col-sm-1 text-end" (click)="onSelectProvider(provider)">
                  <img class="img-pointer" *ngIf="provider.id != idProviderSelected"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_more.svg' | company" alt="">
                  <img class="img-pointer" *ngIf="provider.id == idProviderSelected"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_less.svg' | company" alt="">
                </div>
              </div>
            </div>
            <div class="card-body pt-0" *ngIf="provider.id == idProviderSelected">
              <form class="form-horizontal" #form="ngForm">
                <div class="row mb-3">
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <strong *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ 'Description' | translate }}:
                    </strong>
                    <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ coveragePrice?.note }}</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <div>
                      <label class="control-label">
                        {{ 'Status' | translate }}:
                      </label>
                      <div>
                        <select name="status" class="form-control" [(ngModel)]="editticket.provider_status">
                          <option [ngValue]="1">
                            {{ 'Will go' | translate }}
                          </option>
                          <option [ngValue]="2">
                            {{ 'Won\'t go' | translate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="editticket.provider_status == 1 && assistancecase">
                    <div class="col-md-4">
                      <div *ngIf="editticket.provider_status == 1">
                        <label class="control-label">
                          {{ 'Provider user phone number' | translate }}:
                        </label>
                        <div>
                          <textarea rows="1" cols="10" class="form-control" name="number_provider" style="resize: none;"
                            placeholder="{{ 'Provider phone number' | translate }}"
                            [(ngModel)]="editticket.number_provider">
                    </textarea>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div *ngIf="editticket.provider_status == 1 && MedicalCategories.indexOf(editcategory.id) == -1">
                        <label class="control-label">
                          {{ 'Estimated time arrival' | translate }}:
                        </label>
                        <div>
                          <input step="0.01" type="number" name="timeestimated" class="form-control"
                            placeholder="{{ 'Minutes' | translate }}" [(ngModel)]="editticket.timeestimated">
                        </div>
                      </div>
                      <div *ngIf="(provider.network_type == 1 || provider.network_type == 4) || provider.network_type == 3">
                        <label class="control-label">
                          {{ 'Send Letter' | translate }}:
                        </label>
                        <div>
                          <input class="form-check-input" type="checkbox" name="sendletter" [(ngModel)]="sendletter" [checked]="sendletter">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4)">
                      <label class="control-label">
                        {{'Appointment date and time' | translate}}:
                      </label>
                      <p-datepicker [showIcon]="true" [required]="true" name="dateControl" dateFormat="dd/mm/yy"
                        [(ngModel)]="appointmentDate" [showTime]="true" hourFormat="12">
                      </p-datepicker>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4)">
                      <label class="control-label">
                        {{ 'Address' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Address' | translate }}"
                          [(ngModel)]="address" name="address" required>
                        </textarea>
                      </div>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4)">
                      <label class="control-label">
                        {{ 'Coordinated by' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Coordinated by' | translate }}"
                          [(ngModel)]="agente" name="agente" required>
                        </textarea>
                      </div>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4) && copago">
                      <label class="control-label">
                        {{ 'Participation Amount' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Participation Amount' | translate }}"
                          [(ngModel)]="cost_" name="cost_" required>
                        </textarea>
                      </div>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4)">
                      <label class="control-label">
                        {{ 'Sub Category' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Sub Category' | translate }}"
                          [(ngModel)]="subCategory" name="subCategory" required>
                        </textarea>
                      </div>
                    </div>
                    <div class="col-md-4 date-content" *ngIf="(provider.network_type == 1 || provider.network_type == 4)">
                      <label class="control-label">
                        {{ 'Reference Cases' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Reference Cases' | translate }}"
                          [(ngModel)]="cases_ids" name="cases_ids">
                        </textarea>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="editticket.provider_status == 2 && assistancecase">
                    <div class="col-md-8">
                      <div>
                        <label class="control-label">
                          {{ 'Provider cancellation reason' | translate }}:
                        </label>
                        <div>
                          <select name="state_origin_id" class="form-control"
                            [(ngModel)]="id_provider_cancellation_reason"
                            (ngModelChange)="onSelectProviderCancellationReason($event)" required>
                            <option [ngValue]="null">---</option>
                            <option *ngFor="let reason of catalog_provider_cancellation_reasons"
                              [ngValue]="reason.value_">
                              {{ reason.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="row mb-3" *ngIf="(assistance_plan_service.sinister_apply === 1) || (assistance_plan_service.buca_apply === 1)">
                  <div class="col-md-8">
                    <div>
                      <label class="control-label" *ngIf="assistance_plan_service.sinister_apply === 1">
                        {{ 'Provider user' | translate }}:
                      </label>
                      <label class="control-label" *ngIf="assistance_plan_service.buca_apply === 1">
                        {{ 'Dentist' | translate }}:
                      </label>
                      <div>
                        <select name="dentist" class="form-control" required [(ngModel)]="new_provider_id">
                          <option *ngIf="assistance_plan_service.buca_apply === 1" hidden [ngValue]="null">--- Seleccione un Odontólogo --- </option>
                          <option *ngIf="assistance_plan_service.sinister_apply === 1" hidden [ngValue]="null">--- Seleccione un Proveedor ---
                          </option>
                          <option *ngFor="let user of siteUsers" [ngValue]="user.id">
                            {{ user.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8  date-content" *ngIf="assistance_plan_service.buca_apply === 1">
                    <div>
                      <label class="control-label">
                        {{ 'Address' | translate }}:
                      </label>
                      <div>
                        <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Address' | translate }}"
                          [(ngModel)]="address" name="address" required>
                    </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8  date-content" *ngIf="assistance_plan_service.buca_apply === 1">
                    <div>
                      <label class="control-label">
                        {{ 'Sub Category' | translate }}:
                      </label>
                      <div>
                        <input type="text" class="form-control" [(ngModel)]="subCategory" name="searchProvider"
                          required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 date-content" *ngIf="assistance_plan_service.buca_apply === 1">
                    <label class="control-label">
                      {{'Appointment date and time' | translate}}:
                    </label>
                    <p-datepicker [showIcon]="true" [required]="true" name="dateControl" dateFormat="dd/mm/yy"
                      [(ngModel)]="appointmentDate" [showTime]="true" hourFormat="12" appendTo="body">
                    </p-datepicker>
                  </div>
                </div>
                <div class="row mb-3" *ngIf="isAppCase && provider.users">
                  <div class="col-md-8">
                    <div>
                      <label class="control-label">
                        {{ 'Mobile App Users' | translate }}:
                      </label>
                      <div>
                        <select name="selectApp" class="form-control" [(ngModel)]="editticket.app_user_id">
                          <option *ngFor="let user of provider.users" [ngValue]="user.id">
                            {{ user.email }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-comment-provider w-100" *ngIf="editticket.provider_status !== 3">
                  <!-- Botón para abrir modal de fórmulas -->
                  <div class="mb-3" *ngIf="isNewConfigActive">
                    <button type="button" 
                            class="btn btn-outline-primary btn-sm"
                            (click)="openFormulaModal(provider?.provider_site?.id)"
                            title="Calcular precio con fórmula">
                      <i class="fa fa-calculator me-2"></i>
                      Iniciar prefacturación
                    </button>
                  </div>
                  <textarea rows="5" cols="10" class="form-control" placeholder="{{ 'Write a comment' | translate }}"
                    [(ngModel)]="comment" name="comment" required>
              </textarea>
                </div>
                <div class="body-card-provider">
                  <button class="btn primary-btn-green btn primary-btn-fw m-0">
                    <img
                      [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company"
                      alt="">
                    {{ 'To call' | translate }}
                  </button>
                  <button class="btn primary-btn btn primary-btn-fw m-0"
                    [disabled]="form.form.invalid || form.form.pending" (click)="onSubmit()"> {{ 'Assign' | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card internal-card " style="height: 160px;" *ngIf='isLoading'>
            <div class="card-body col" >
              <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                <div class="col" style="display: flex; gap: 10px; justify-content: space-between;">
                  <div class="skeleton" style="width: 65%; height: 20px;"></div>
                  <div class="skeleton" style="width: 10%; height: 16px;"></div>
                </div>
                <div class="col" style="display: flex; gap: 10px;">
                  <div class="skeleton" style="width: 50%; height: 20px;"></div>                
                </div>
                <div class="col" style="display: flex; flex-direction: column; gap: 10px;">
                  <div class="skeleton" style="width: 30%; height: 20px;"></div>
                  <div class="skeleton" style="width: 20%; height: 20px;"></div>
                </div>
              </div>
            </div>
        </div>
        <div class="row" class="float-div">
            <div class="col text-center" style="display: flex; justify-content: center; align-items: center; height: 100%">
              <button class="btn secundary-btn secundary-btn-fw" (click)="seeMoreProvider()"><strong> {{ 'See more providers' | translate }} </strong></button>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="div-map-info">
    <div style="width: 100%; height: 64vh;">
      <p-gmap *ngIf="providers.length" [options]="mapOptions" [style]="{width:'100%', height:'100%'}"
        [overlays]="mapOverlays" (onMapReady)="setMap($event)" #providersMap>
      </p-gmap>
    </div>
    <div class="card internal-card" style="width: 95%;">
      <div class="card-body">
        <div class="div-info-assistancecase">
          <div class="div-data-vehicle-50">
            <img class="img-details"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company"
              alt="">
            <hr>
            <p><strong>{{ 'Vehicle data' | translate }}:</strong></p>
            <p
              *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elsebrand">
              {{ assistanceSaleCar?.brand_description }}</p>
            <ng-template #elsebrand>
              <p>{{ servicegroup?.brand_description || servicegroup?.car_brand_desc || servicegroup?.car_model?.brand?.name }}</p>
            </ng-template>
            <p
              *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elsemodel">
              {{ assistanceSaleCar?.model_description }}</p>
            <ng-template #elsemodel>
              <p>{{ servicegroup?.model_description || servicegroup?.car_model_desc || servicegroup?.car_model?.name }}</p>
            </ng-template>
          </div>
          <div class="div-data-vehicle-50">
            <p><strong>{{ 'Car Year' | translate }}:</strong></p>
            <hr style="margin: 0 3px;">
            <p
              *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elseyear">
              {{ assistanceSaleCar?.car_year }}</p>
            <ng-template #elseyear>
              <p>{{ servicegroup?.car_year }}</p>
            </ng-template>
          </div>
        </div>
        <div class="div-info-assistancecase">
          <div class="div-data-vehicle-50" style="padding-left: 67px;">
            <p><strong>{{ 'Car Plate' | translate }}:</strong></p>
            <hr style="margin: 0 3px;">
            <p
              *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elseplate">
              {{ assistanceSaleCar?.car_plate }}</p>
            <ng-template #elseplate>
              <p>{{ servicegroup?.car_plate }}</p>
            </ng-template>
          </div>
          <div class="div-data-vehicle-50">
            <p><strong>{{ 'Car Color' | translate }}:</strong></p>
            <hr style="margin: 0 3px;">
            <p>{{ assistanceSaleCar?.color_description || servicegroup?.color_description || servicegroup?.car_color_desc }}</p>
          </div>
        </div>
        <br>
        <div class="div-info-assistancecase">
          <div class="div-data-vehicle-100">
            <img class="mrg-rg"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/client_data.svg' | company"
              alt="">
            <hr>
            <p><strong>{{ 'Data of the Holder' | translate }}</strong></p>
            <hr style="margin: 0 3px;">
            <p>{{ assistancecase?.member?.name }}</p>
          </div>
        </div>
        <div class="div-info-assistancecase">
          <div class="div-data-vehicle-75" >
            <img
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company"
              alt="">
            <hr>
      

            <div class="row">
              <div [ngClass]="have_coordinates ? 'col-md-6' : 'col-12'">
                <p-messages [enableService]="false" [(value)]="msgs" [closable]="false"></p-messages>
              </div>
            
              <div *ngIf="have_coordinates" class="col-md-6 d-flex align-items-center">
               
                <p><strong> {{ 'Link location' | translate }}: </strong></p>
                <hr style="margin: 0 3px;">
                <p (click)="openLinkLocationCustomer()" style="color: #70BE21; cursor: pointer;"><u> {{ 'Client location' | translate }} </u></p>
    
    
              </div>
            </div>




            
          </div>
          <div class="div-data-vehicle-25" (click)="copyText(assistancecase.phone)">
            <img style="width: 22px;"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company"
              alt="">
            <hr style="margin: 0 3px;">
            <p style="color: #70BE21; cursor: pointer; display: flex; align-items: center; justify-content: center;">
              <u>{{ assistancecase?.phone }}</u>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- See more providers -->
<p-dialog [(visible)]="showSeeMoreProviders" [modal]="true" [draggable]="false" [blockScroll]="true" [positionTop]="100"
  (onHide)="hideProviderCard()" [style]="{width: '80vw', height: '50vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Search providers' | translate }}
  
  </ng-template>
  
  <div class="container">
    <form class="row" #form="ngForm">
      <div class="col-sm-4">
        <label class="control-label">{{ 'Country' | translate }}</label>
        <select name="country_" class="form-control" (ngModelChange)="onSelectCountry($event)" [(ngModel)]="country_id"
          required>
          <option [ngValue]="null">---</option>
          <option [ngValue]="0">Todos los Paises</option>
          <option *ngFor="let country of countries" [ngValue]="country.id">
            {{ country.name }}
          </option>

        </select>
      </div>
      <div class="col-sm-4">
        <label class="control-label">{{ 'State' | translate }}</label>
        <select [disabled]="country_id == 0" name="state_origin_id" class="form-control"
          (ngModelChange)="onSelectState($event)" [(ngModel)]="state_id">
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of states" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <label class="control-label">{{ 'District' | translate }}</label>
        <select [disabled]="country_id == 0" name="state_district_origin_id" class="form-control"
          [(ngModel)]="state_district_id">
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of statesDistrict" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <label class="control-label">{{ 'Provider' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="searchProvider" name="searchProvider">
      </div>
      <div class="col-sm-4 pt-4">
        <button [disabled]="!(state_district_id || searchProvider)" type="button"
          class="btn primary-btn btn primary-btn-fw m-0" (click)="getProviders()"> {{ 'Filter' | translate }} </button>
      </div>
    </form>
    <div class="row mt-3">
      <div class="col">
        <div class="card internal-card mb-3" *ngFor="let provider of providersAll">
          <div class="card-body col">
            <div class="row mb-2">
              <div class="col">
                <div style="display: flex; width: 100%; justify-content: space-between;">
                  <strong>{{ provider?.provider_site?.id }} {{ provider?.provider_site?.name }}</strong>
                  <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 1">
                    {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}}
                  </strong>
                  <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 2">
                    {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}} / Km
                  </strong>
                  <strong *ngIf="!provider?.provider?.price">
                    N/A
                  </strong>
                </div>
                <span style="font-size: 0.9rem;">{{ provider?.provider?.id }} {{ provider?.provider?.name
                  }}</span>
                <br>
                <span style="font-size: 0.7rem;">{{ provider?.provider?.cabin_emails }}</span>
                <br>
                <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                  <span *ngIf="coveragePrice.id == provider?.assistancePrice_id" style="font-size: 0.7rem;">{{
                    "Attention Times" | translate }} {{ coveragePrice?.hour_end }} - {{ coveragePrice?.hour_start
                    }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                  <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ "Cancellation" | translate }} {{
                    coveragePrice?.price_cancellation }}%</span>
                </div>
              </div>
              <div class="col">
                <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                  <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{provider?.provider?.currency_symbol}}
                    {{ coveragePrice?.price_extra != null ? coveragePrice?.price_extra : '-' }}/km</span>
                </div>
              </div>
              <div class="col">
                <div *ngFor="let contactPhone of ((provider.provider_site.cabin_phones || '')).split(',')">
                  <span>
                    <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/phone.svg' | company"
                      alt=""> {{ contactPhone }}
                  </span>
                </div>
              </div>
              <div class="col">
                <span *ngIf="provider?.coverage?.coverage_type == 1">
                  Plano {{ provider?.coverage?.plane }}
                </span>
                <span *ngIf="provider?.coverage?.coverage_type == 2">
                  Foráneo
                </span>
              </div>
              <div class="col-sm-1 text-end" (click)="onSelectProvider(provider, true)">
                <img class="img-pointer" *ngIf="provider.id != idProviderSelected"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_more.svg' | company" alt="">
                <img class="img-pointer" *ngIf="provider.id == idProviderSelected"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_less.svg' | company" alt="">
              </div>
            </div>
          </div>
          <div class="card-body col pt-0" *ngIf="provider.id == idProviderSelected">
            <div class="row mb-3">
              <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                <strong *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ 'Description' | translate }}:
                </strong>
                <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ coveragePrice?.note }}</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-4">
                <div>
                  <label class="control-label">
                    {{ 'Status' | translate }}:
                  </label>
                  <div>
                    <select name="status" class="form-control" [(ngModel)]="editticket.provider_status">
                      <option [ngValue]="1">
                        {{ 'Will go' | translate }}
                      </option>
                      <option [ngValue]="2">
                        {{ 'Won\'t go' | translate }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div *ngIf="editticket.provider_status == 1">
                  <label class="control-label">
                    {{ 'Provider phone number' | translate }}:
                  </label>
                  <div>
                    <textarea rows="1" cols="10" class="form-control" name="number_provider" style="resize: none;"
                      placeholder="{{ 'Provider phone number' | translate }}" [(ngModel)]="editticket.number_provider">
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div *ngIf="editticket.provider_status == 1 && MedicalCategories.indexOf(editcategory.id) == -1">
                  <label class="control-label">
                    {{ 'Estimated time arrival' | translate }}:
                  </label>
                  <div>
                    <input step="0.01" type="number" name="timeestimated" class="form-control" required
                      placeholder="{{ 'Minutes' | translate }}" [(ngModel)]="editticket.timeestimated">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3" *ngIf="assistance_plan_service.sinister_apply === 1">
              <div class="col-md-8">
                <div>
                  <label class="control-label" *ngIf="assistance_plan_service.sinister_apply === 1">
                    {{ 'Provider user' | translate }}:
                  </label>
                  <div>
                    <select name="dentist" class="form-control" required [(ngModel)]="new_provider_id">
                      <option *ngIf="assistance_plan_service.sinister_apply === 1" hidden [ngValue]="null">--- Seleccione un Proveedor ---
                      </option>
                      <option *ngFor="let user of siteUsers" [ngValue]="user.id">
                        {{ user.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-comment-provider w-100" *ngIf="editticket.provider_status !== 3">
              <textarea rows="5" cols="10" class="form-control" placeholder="{{ 'Write a comment' | translate }}"
                [(ngModel)]="comment" name="comment" required>
              </textarea>
            </div>
            <div class="body-card-provider">
              <button class="btn primary-btn-green btn primary-btn-fw m-0">
                <img
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company"
                  alt="">
                {{ 'To call' | translate }}
              </button>
              <button class="btn primary-btn btn primary-btn-fw m-0" (click)="onSubmit()"> {{ 'Assign' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog header="{{ 'Assign new provider' | translate }}" [(visible)]="showNewDialog" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <form class="form-horizontal" #newProviderform="ngForm" (ngSubmit)="onSubmitOutOfNetworkProvider()">
    <div class="mb-3 row">
      <div class="form-group col-sm-6" [class.has-error]="name.invalid && name.touched">
        <label class="control-label">{{ 'Name' | translate }}:</label>
        <div>
          <input type="text" class="form-control" [(ngModel)]="editOutNetworkProvider.name" name="name" #name="ngModel"
            required>
        </div>
      </div>
      <div class="form-group col-sm-6" [class.has-error]="phone.invalid && phone.touched">
        <label class="control-label">{{ 'Phone' | translate }}:</label>
        <div>
          <input type="text" class="form-control" [(ngModel)]="editOutNetworkProvider.phone" name="phone"
            #phone="ngModel" required>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="form-group col-sm-6" [class.has-error]="service.invalid && service.touched">
        <label class="control-label">{{ 'Service' | translate }}:</label>
        <div>
          <input type="text" class="form-control" [(ngModel)]="editOutNetworkProvider.service" name="service"
            #service="ngModel" required>
        </div>
      </div>
      <div class="form-group col-sm-6" [class.has-error]="cost.invalid && cost.touched">
        <label class="control-label">{{ 'Cost' | translate }}:</label>
        <div>
          <input type="number" class="form-control" [(ngModel)]="editOutNetworkProvider.cost" name="cost"
            #cost="ngModel" required>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="form-group col-sm-12" [class.has-error]="headquartersAddress.invalid && headquartersAddress.touched">
        <label class="control-label">{{ 'Headquarters Address' | translate }}:</label>
        <div>
          <input type="text" class="form-control" [(ngModel)]="editOutNetworkProvider.headquartersAddress"
            name="headquartersAddress" #headquartersAddress="ngModel">
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="form-group col-sm-12">
        <label class="control-label">
          {{ 'Comment' | translate }}:
        </label>
        <div>
          <textarea rows="5" cols="10" class="form-control" [(ngModel)]="editOutNetworkProvider.comment" name="comment">
          </textarea>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-md-12 text-center">
        <button type="submit" class="btn primary-btn primary-btn-fw"
          [disabled]="newProviderform.form.invalid || newProviderform.form.pending">
          {{ 'Assign' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [(visible)]="showProviderUserDialog" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [positionTop]="100" (onHide)="hideProviderUsers()">
  <ng-template pTemplate="header">
    
    {{ 'Provider Information' | translate }}
  
  </ng-template>
  
  <app-asign-user-provider
  [is_visible]="is_visible"
  [is_confirmation_visible]="is_confirmation_visible"
  [user_providers]="providers_app"
  [provider_app]="provider_app"
  [case_id]="case_id"
  [isNormalCase]="isNormalCase"
  (done)="onSelectedUserProvider($event)"
  (closeconfirm)="closeConfirm($event)"
  [showEstimatedTime]="MedicalCategories.indexOf(editcategory.id) == -1">
  </app-asign-user-provider>
</p-dialog>

<!-- Modal de selección de fórmulas -->
<p-dialog [(visible)]="showFormulaModal" 
          [responsive]="true" 
          [modal]="true" 
          [draggable]="false" 
          [breakpoint]="500"
          [blockScroll]="true" 
          [positionTop]="100"
          [style]="{'width': '90vw', 'max-width': '900px'}"
          [header]="'Seleccionar Fórmula de Precio'"
          (onHide)="closeFormulaModal()">

  <!-- Loading inicial -->
  <div *ngIf="formulaLoading && !selectedFormula" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-2">Cargando fórmulas...</p>
  </div>

  <!-- Error -->
  <div *ngIf="formulaError" class="alert alert-danger">
    <i class="fa fa-exclamation-triangle me-2"></i>
    {{ formulaError }}
  </div>

  <!-- Lista de fórmulas -->
  <div *ngIf="!formulaLoading && !formulaError && (availableFormulas?.length > 1)" class="formulas-list">
    <div class="mb-3">
      <h6>Fórmulas Disponibles:</h6>
      <p class="text-muted small">
        Selecciona una fórmula para calcular el precio automáticamente
      </p>
    </div>

    <div class="formula-items">
      <div *ngFor="let formula of availableFormulas" 
           class="formula-item mb-3 p-3 border rounded"
           [class.selected]="selectedFormula?.id === formula.id"
           (click)="selectFormula(formula)"
           style="cursor: pointer; transition: all 0.2s ease;">
        <div class="d-flex justify-content-between align-items-start">
          <div class="flex-grow-1">
            <h6 class="formula-name mb-1">{{ formula.name }}</h6>
            <p class="formula-description text-muted mb-1">{{ formula.expression }}</p>
            <small class="text-muted">
              Creada: {{ formula.createdAt | date:'dd/MM/yyyy HH:mm' }}
            </small>
          </div>
          <div class="formula-status">
            <span class="badge" [ngClass]="formula.isActive ? 'bg-success' : 'bg-secondary'">
              {{ formula.isActive ? 'Activa' : 'Inactiva' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensaje cuando no hay fórmulas disponibles -->
  <div *ngIf="!formulaLoading && !formulaError && (availableFormulas?.length === 0)" class="no-formulas text-center py-4">
    <i class="fa fa-info-circle fa-2x text-muted mb-2"></i>
    <p class="text-muted">No hay fórmulas configuradas para este servicio</p>
  </div>

  <!-- Si hay exactamente una fórmula, ocultar la lista y mostrar aviso / detalles (el TS selecciona y calcula automáticamente) -->
  <div *ngIf="!formulaLoading && !formulaError && (availableFormulas?.length === 1) && selectedFormula" class="auto-selected-formula">
    <div class="alert alert-info">
      <i class="fa fa-info-circle me-2"></i>
      Se seleccionó automáticamente la fórmula: <strong>{{ selectedFormula.name }}</strong>
    </div>
  </div>

  <!-- Campos dinámicos y resultado -->
  <div *ngIf="selectedFormula" class="formula-details mt-4">
    <hr>
    <h6>Configuración de Campos:</h6>

    <div class="dynamic-fields mb-3">
      <div class="row">
        <div *ngFor="let field of dynamicFields" 
             class="col-md-6 mb-2">
          <div class="field-input-group">
            <label class="form-label small">
              {{ field.name }}
              <span class="text-muted">({{ getFieldTypeLabel(field.type) }})</span>
            </label>

            <!-- Campo de texto -->
            <input *ngIf="field.type === 'text'" 
                   type="text" 
                   class="form-control form-control-sm"
                   [placeholder]="'Valor para ' + field.name"
                   [value]="fieldValues[field.id]"
                   (input)="onFieldValueChange(field.id, $event)">

            <!-- Campo de número -->
            <input *ngIf="field.type === 'number'" 
                   type="number" 
                   step="0.01"
                   class="form-control form-control-sm"
                   [placeholder]="'Valor para ' + field.name"
                   [value]="fieldValues[field.id]"
                   (input)="onFieldValueChange(field.id, $event)">

            <!-- Campo booleano -->
            <div *ngIf="field.type === 'boolean'" class="form-check">
              <input type="checkbox" 
                     class="form-check-input"
                     [id]="'field_' + field.id"
                     [checked]="fieldValues[field.id]"
                     (change)="onFieldValueChange(field.id, $event)">
              <label class="form-check-label" [for]="'field_' + field.id">
                {{ field.name }}
              </label>
            </div>

            <!-- Campo de lista desplegable -->
            <select *ngIf="field.type === 'combo'" 
                    class="form-control form-control-sm"
                    [value]="fieldValues[field.id]"
                    (change)="onFieldValueChange(field.id, $event)">
              <option *ngFor="let option of field.options" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading del cálculo -->
    <div *ngIf="formulaLoading && selectedFormula" class="formula-loading">
      <div class="alert alert-info">
        <div class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm text-primary me-3" role="status">
            <span class="visually-hidden">Calculando...</span>
          </div>
          <div>
            <h6 class="mb-1">
              <i class="fa fa-calculator me-2"></i>
              Calculando Fórmula
            </h6>
            <p class="mb-0 text-muted">Procesando los valores y evaluando la fórmula...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultado de la fórmula -->
    <div *ngIf="formulaResult && !formulaLoading" class="formula-result">
      <div class="alert alert-success">
        <h6 class="mb-2">
          <i class="fa fa-check-circle me-2"></i>
          Resultado del Cálculo
        </h6>
        <div class="result-details">
          <p class="mb-1">
            <strong>Ecuación:</strong> {{ formulaResult.expression }}
          </p>
          <p class="mb-0">
            <strong>Total:</strong> 
            <span class="h5 text-success mb-0">
              {{ formulaResult.total | currency:'USD':'symbol':'1.2-2' }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no hay resultado -->
    <div *ngIf="selectedFormula && !formulaResult && !formulaError && !formulaLoading" class="formula-pending">
      <div class="alert alert-info">
        <h6 class="mb-2">
          <i class="fa fa-info-circle me-2"></i>
          Listo para Calcular
        </h6>
        <p class="mb-0">
          Configura los valores de los campos y haz clic en "Calcular" para obtener el resultado.
        </p>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="mt-3 text-center">
      <button type="button" 
              class="btn btn-success me-2"
              [disabled]="!selectedFormula || formulaLoading"
              (click)="calculateFormula()"
              title="Calcular la fórmula con los valores actuales">
        <i class="fa fa-calculator me-2"></i>
        Calcular
      </button>
    </div>
  </div>

  <p-footer>
    <button type="button" 
            class="btn btn-secondary me-2" 
            (click)="closeFormulaModal()">
      Cancelar
    </button>
    <button type="button" 
            class="btn btn-info me-2" 
            [disabled]="!selectedFormula || !formulaResult || formulaLoading"
            (click)="setQuotationComment()">
      <i class="fa fa-comment me-2"></i>
      Comentario de Cotización
    </button>
    <button type="button" 
            class="btn btn-primary" 
            [disabled]="!selectedFormula || !formulaResult || formulaLoading"
            (click)="useFormula()">
      <i class="fa fa-check me-2"></i>
      Guardar
    </button>
  </p-footer>
</p-dialog>